import React from "react";
import { TextFieldProps } from "@mui/material";
import { FormController, MuiSelect, MuiTextField, MuiTypography } from "..";
import { MuiSelectWithTextInputWrapper } from "./MuiSelectWithTextInput.style";
import { Control } from "react-hook-form";
import { useMediaQueries } from "../../hooks/useMediaQueries";

type MuiSelectWithTextInputProps = TextFieldProps & {
  error?: boolean;
  helperText?: string;
  options: { value: string | number; label: string }[];
  label?: string;
  control: Control<any>;
  selectBoxName: string;
  selectBoxId: string;
  maxLength: number;
  requiredARIALabel: string;
  placeholder: string;
  tooltipMessage?: string;
  tooltipHeaderTitle?: string;
};

export const MuiSelectWithTextInput: React.FC<MuiSelectWithTextInputProps> = ({
  error,
  helperText,
  options,
  label = "",
  control,
  selectBoxName,
  selectBoxId,
  maxLength,
  requiredARIALabel,
  placeholder,
  tooltipMessage,
  tooltipHeaderTitle,
  ...rest
}) => {
  const { isMobile } = useMediaQueries();
  const inputId = rest.id || `${selectBoxId}-input`;

  return (
    <MuiSelectWithTextInputWrapper>
      {label && (
        <MuiTypography
          className="mui-label-select"
          component="label"
          variant="h3"
          htmlFor={inputId}
        >
          {label}
        </MuiTypography>
      )}
      <MuiTextField
        id={inputId}
        labelText=""
        variant="outlined"
        error={error}
        helperText={helperText}
        placeholder={placeholder}
        tooltipMessage={tooltipMessage}
        tooltipHeaderTitle={tooltipHeaderTitle}
        startAdornment={
          !isMobile && (
            <FormController control={control} name={selectBoxName}>
              <MuiSelect
                className="dropdown-prefix"
                label=""
                options={options}
                error={error}
                value=""
                id={selectBoxId}
                requiredARIALabel={requiredARIALabel}
                placeholder={placeholder}
              />
            </FormController>
          )
        }
        fullWidth
        aria-describedby={helperText ? `${inputId}-helper-text` : undefined}
        aria-label={!label ? placeholder || requiredARIALabel : undefined}
        maxLength={maxLength}
        requiredARIALabel={requiredARIALabel}
        {...rest}
      />
    </MuiSelectWithTextInputWrapper>
  );
};
